// eslint-disable-next-line
import React, { useState } from 'react';
import { X } from 'lucide-react';
import cicleto from '../../assets/transparent-Photoroom.png';
import logo from '../../assets/images/LogoNav.png';
import Grafica from '../cards/Grafica'; // Import the Grafica component
import './InvestigacionModal.css';

const InvestigacionModal = ({ isOpen, onClose }) => {
  const [currentView, setCurrentView] = useState('investigacion'); // State to manage current view

  if (!isOpen) return null;

  // Function to handle view change
  const handleNextClick = () => {
    setCurrentView('grafica');
  };

  // Function to go back to investigacion view
  const handleBackClick = () => {
    setCurrentView('investigacion');
  };

  // Render Grafica component if currentView is 'grafica'
  if (currentView === 'grafica') {
    return (
      <div className="modal-overlay-grafica">
        <div className="modal-content-grafica" style={{ padding: '0' }}>
          {/* Close button */}
          <button onClick={onClose} className="close-button">
            X
          </button>

          {/* Back button */}
          <button
            className="back-button"
            onClick={handleBackClick}
            style={{
              position: 'absolute',
              top: '350px',
              left: '20px',
              color: '#999',
              border: 'none',
              width: '40px',
              height: '40px',
              fontSize: '28px',
              cursor: 'pointer',
              display: 'flex',
              zIndex: 1000,
              background: 'transparent',
              fontWeight: 'bold',
            }}
          >
            &lt;
          </button>

          {/* Render Grafica component */}
          <Grafica />
        </div>
      </div>
    );
  }

  // Original InvestigacionModal content
  return (
    <div className="modal-overlay-grafica">
      <div className="modal-content-grafica">
        {/* Botón cerrar */}
        <button onClick={onClose} className="close-button">
          <X size={20} />
        </button>

        {/* Header */}
        <div className="modal-header">
          <h1 className="modal-title">
            Eficacia y seguridad de la triple terapia
            <br />
            inhalada con formoterol/tiotropio/ciclesonida
            <br />
            en pacientes con EPOC GOLD-E
          </h1>
        </div>
        <p className="publication-info">
          PUBLICADO EN LA GACETA MÉDICA DE CARACAS, VOL. 131(1), MARZO 2025
        </p>

        {/* Autores */}
        <div className="authors-section">
          <p className="authors-text">
            <strong className="Autores">Autores:</strong> Maryalejandra Mendoza
            de Sifontes, Jose Bastidas Ramos, Maria Arias Labrador, Rafael Gil
            Barrientos, Miryana Silva Arguello, Fanny Ochoa Ochoa, Yamile
            Aparicio de Marín
          </p>
        </div>

        {/* Main content area */}
        <div className="modal-main">
          {/* Objetivo */}
          <div className="section">
            <div className="section-banner">
              <div className="banner-icon">🔍</div>
              <span className="banner-title">Objetivo del estudio:</span>
            </div>
            <p className="section-text">
              Evaluar la eficacia clínica y seguridad a mediano plazo de la
              combinación inhalada de{' '}
              <strong>
                formoterol 6 μg, tiotropio 9 μg y ciclesonida 200 μg
              </strong>{' '}
              en una sola dosis en pacientes con EPOC GOLD-E, administrada en
              pMDI con cámara espaciadora, <strong>durante 12 semanas</strong>.
            </p>
          </div>

          {/* Esquema clínico */}
          <div className="section-clinico">
            <div className="section-banner gray">
              <div className="banner-icon gray">
                <span>📋</span>
              </div>
              <span className="banner-title">Esquema clínico:</span>
            </div>
            <ul className="bullet-list">
              <li className="bullet-item">
                <span className="bullet-point"></span> Ensayo clínico
                aleatorizado, controlado y no ciego.
              </li>
              <li className="bullet-item">
                <span className="bullet-point"></span> N=80 pacientes con EPOC
                GOLD-E (confirmado por espirometría pos-BD).
              </li>
              <li className="bullet-item">
                <span className="bullet-point"></span> Dos grupos de
                intervención: 1 vs. 2 inhalaciones cada 12 h.
              </li>
              <li className="bullet-item">
                <span className="bullet-point"></span> Variables: disnea (mMRC),
                CAT, VEF1, caminata de 6 minutos (PC6M), exacerbaciones y
                eventos adversos
              </li>
            </ul>
          </div>

          {/* Resultados */}
          <div className="section">
            <div className="results-section">
              <h3 className="results-title">
                Resultados clínicos destacados (n=70):
              </h3>
              <div className="results-grid">
                <div className="results-column">
                  <div>• Disnea (mMRC): disminuyó 1 punto (p&lt;0.001)</div>
                  <div>• VEF1: aumento de +70ml (p&lt;0.071)</div>
                  <div>• Reducción de exacerbaciones: -56.8%</div>
                </div>
                <div className="results-column">
                  <div>• CAT: disminución de 6.3 puntos (p&lt;0.001)</div>
                  <div>• Caminata 6 min: +27 m (p&lt;0.001)</div>
                  <div>• Reducción de hospitalizaciones: -90%</div>
                </div>
              </div>
            </div>
            <div className="safety-section">
              <h3 className="safety-title">Seguridad y tolerabilidad</h3>
              <ul className="safety-list">
                <li className="bullet-item">
                  <span className="bullet-point"></span> Bien tolerado. Solo 1
                  hospitalización atribuible.
                </li>
                <li className="bullet-item">
                  <span className="bullet-point"></span> EAs: tos leve,
                  disfonía, cefalea.
                </li>
                <li className="bullet-item">
                  <span className="bullet-point"></span> 85.7 % expresó deseo de
                  continuar el tratamiento.
                </li>
              </ul>
            </div>
          </div>

          {/* Conclusiones */}
          <div className="section conclusions-section">
            <div className="section-banner-conclusion">
              <div className="banner-icon">
                <span>💡</span>
              </div>
              <span className="banner-title">Conclusiones:</span>
            </div>
            <div className="conclusion-container">
              <p className="conclusion-text">
                La combinación{' '}
                <span className="purple-text">
                  formoterol/tiotropio/ciclesonida
                </span>{' '}
                <span className="purple-text">
                  mostró
                  <br />
                  resultados clínicos positivos estadísticamente
                  <br />
                  significativos
                </span>{' '}
                en pacientes con EPOC GOLD-E, con mejorías
                <br />
                importantes en síntomas, función pulmonar, capacidad de
                <br />
                ejercicio y reducción de exacerbaciones, confirmando su
                <br />
                eficacia y seguridad como opción terapéutica.
              </p>
              <p className="study-text">
                Estudio realizado por el{' '}
                <span className="purple-text">
                  Grupo de Investigación de
                  <br />
                  Enfermedades Respiratorias de la ULA
                </span>
                . Patrocinado por
                <br />
                BioMercy.
              </p>
            </div>
          </div>

          {/* Producto + logo + slogan */}
          <div className="product-logo-wrapper">
            <div className="product-container">
              <img
                src={cicleto}
                alt="Ciclesona-T 120"
                className="product-image"
              />
            </div>
            <div className="slogan-biomercy">
              <img src={logo} alt="logo" className="logo-biomercy" />
              <p>INNOVAMOS CON PROPÓSITO</p>
            </div>
          </div>

          {/* Button to switch to Grafica view */}
          <div className="change-button-wrapper">
            <button className="next-button" onClick={handleNextClick}>
              &gt;
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestigacionModal;
